import Dropdownable from 'custom_elements/dropdownable'

class ProfileAgent extends Dropdownable {
  init () {
    this.mainClass = 'core-ProfileAgent'
  }
}

export default ProfileAgent
